import { useRef, useEffect, useCallback } from "react";

export function useDebounce(callback, delay) {
  const timeoutRef = useRef(null);
  useEffect(() => () => clearTimeout(timeoutRef.current), []);
  return useCallback(
    (value) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => callback(value), delay);
    },
    [callback, delay]
  );
}
